import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import Home from '@/components/home'
import Search from '@/components/search'
import Ownerships from '@/components/ownerships'
import Features from '@/components/features'
import Map from '@/components/map'
import Table from '@/components/table'
import BarOwnership from '@/components/bar_ownership'
import BarFeatures from '@/components/bar_productfeatures'
import store from '@/store/index.js'
import VueTables from 'vue-tables-2'

Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueTables.ClientTable)

export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }]
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#search',
  render: h => h(Search),
  created: function () {
    this.$store.dispatch('loadShopData')
  }
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#filter_ownership',
  render: h => h(Ownerships)
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#filter_features',
  render: h => h(Features)
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#map',
  render: h => h(Map)
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#datatable',
  render: h => h(Table)
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#bar_ownership',
  render: h => h(BarOwnership)
})

new Vue({ // eslint-disable-line no-new
  store,
  el: '#bar_features',
  render: h => h(BarFeatures)
})

store.subscribe((mutation, state) => {
  if (mutation.type === 'UPDATE_DATA') {
    console.info('data updated')
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js